import { firestoreObject } from "./Firebase";

export const TimestampToDate = (timestamp, format, iso) => {
  if (iso) {
    const date = timestamp.toDate();
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString("en-US").slice(0, -1);
  }

  return timestamp.toDate().toLocaleString("en-US", { ...format });
};

export const DateToTimestamp = (date) => {
  return firestoreObject.Timestamp.fromDate(date);
};

export const ShuffleArray = (array) => {
  let currentIndex = array.length;
  let randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};
